/* eslint-disable no-console */
import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, getStoredState } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import rootReducer from '../reducers/rootReducer';

const config = {
  key: 'biwapp', // key is required
  storage, // storage is now required
};

const reducer = persistReducer(config, rootReducer);

function configureStore(initialState) {
  let store;
  const isProduction = process.env.NODE_ENV === 'production';

  if (!isProduction) {
    if (window.devToolsExtension) {
      // Enable Redux devtools if the extension is installed in developer's browser
      // And the NODE_ENV is not in Production Mode
      store = createStore(
        reducer,
        initialState,
        compose(
          applyMiddleware(thunkMiddleware),
          window.devToolsExtension ? window.devToolsExtension() : f => f,
        ),
      );
    } else {
      store = createStore(reducer, initialState, applyMiddleware(thunkMiddleware));
    }
  } else {
    store = createStore(reducer, initialState, applyMiddleware(thunkMiddleware));
  }

  if (module.hot && !isProduction) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/rootReducer', () => {
      const nextReducer = require('../reducers/rootReducer').default; // eslint-disable-line
      store.replaceReducer(nextReducer);
    });
  }

  persistStore(store);
  return store;
}

export default () =>
  new Promise(resolve => {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      console.warn('I am Offline. Loading last saved Store from Cache');
      getStoredState(config)
        .then(restoredState => {
          console.log(restoredState);
          resolve(configureStore(restoredState));
        })
        .catch(err => {
          console.error(err);
        });
    }
    return resolve(configureStore());
  });



// WEBPACK FOOTER //
// ./src/js/store/store.js